/**
 * CRS 가 받지 않는 MSIC 업종.
 *
 * 2026-09-23 CRS `rocIncorporationLookup` 코드표(2,602건)와 우리 표(2,604건)를 전수 대조한
 * 결과, 우리에게만 있는 코드가 이 셋이다. 전부 84xxx(공공행정) 계열이라 사기업이 신고할 수
 * 있는 업종이 아니다.
 *
 *   84133 Primary Industries Affairs
 *   84137 Tourism Affairs
 *   84233 Immigration Service
 *
 * 고르면 CRS 제출 단계에서 막히므로 **설립 신고로 이어지는 화면(T-Link · DI)에서는 아예
 * 선택지에 넣지 않는다**. 고르고 나서 막히는 것보다 애초에 안 보이는 편이 낫다.
 *
 * 공용 코드표(msic-codes.json / businessCodes.json)에서는 지우지 않는다 — AR·레지스터가 같은
 * 표를 읽어서, 이미 이 코드를 가진 기존 엔티티의 업종 설명이 빈칸으로 떨어진다.
 */
export const CRS_UNFILABLE_MSIC = new Set(['84133', '84137', '84233']);

/** 행에서 MSIC 코드를 꺼낸다 — 화면마다 키 이름이 달라서(code/TOTAL_CODE/msicCode) 모두 본다. */
const codeOf = (row: any): string =>
  String(row?.code ?? row?.TOTAL_CODE ?? row?.msicCode ?? '').trim();

/** CRS 에 신고할 수 없는 업종을 걷어낸다. */
export function excludeCrsUnfilableMsic<T>(rows: T[]): T[] {
  if (!Array.isArray(rows)) return rows;
  return rows.filter((r) => !CRS_UNFILABLE_MSIC.has(codeOf(r)));
}
